@if (node() && formGroup()) {
<div class="content-panel">
    <form class="content-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden"><a class="tab-link" (click)="onClick(tab)"
                        [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a></li>
                }
            </ul>
        </div>
        <div class="body">
            @if (prototypeModel && contentModel) {
            <div class="row content" [hidden]="tabSelected != tabContent">
                <app-content [tags]="contentModel.tags" [custome]="model().custome" [formGroup]="formGroup()!" [node]="node()" [readonly]="model().readonly"></app-content>
            </div>
            <div class="row publish" [hidden]="tabSelected != tabPublish">
                <app-publish [formGroup]="formGroup()!" [node]="node()"></app-publish>
            </div>
            }
        </div>
        @if (prototypeModel) {
        <div class="footer">
            <div class="row">
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
            </div>
        </div>
        }
    </form>
</div>
}
